var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Bookmark = function Bookmark(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 3a3 3 0 0 0-3 3v14a1 1 0 0 0 1.514.858L12 18.166l4.485 2.692A1 1 0 0 0 18 20V6a3 3 0 0 0-3-3H9Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Bookmark;